(ns frontend.ui.page.fund.sub
  (:require
   [frontend.ui.page.fund.model :as model]
   [re-frame.core :as rf]))

(rf/reg-sub
 ::report-state
 (fn [db [_ fund-id]]
   (model/report-state db fund-id)))

(rf/reg-sub
 ::lp-reports
 (fn [db [_ fund-id]]
   (model/report-items db fund-id)))

(rf/reg-sub
 ::reporting
 (fn [[_ fund-id]]
   (rf/subscribe [::report-state fund-id]))
 (fn [state _]
   (model/state->reporting state)))

(rf/reg-sub
 ::lp-report-header-state
 (fn [[_ fund-id _reporting-admin?]]
   (rf/subscribe [::reporting fund-id]))
 (fn [reporting [_ _fund-id reporting-admin?]]
   (model/lp-report-header-state {:reporting        reporting
                                  :reporting-admin? reporting-admin?})))

(rf/reg-sub
 ::stop-reporting-dialog
 (fn [db [_ fund-id]]
   (model/stop-reporting-dialog db fund-id)))
